/**
 * @internal
 */
export class AbstractLogin {
    /**
     * Used to manage the user's auth states. This should not be instantiated directly.
     * @internal
     */
    constructor({ baseUrl, querier, preLogin, postLogin, client, ecosystem, }) {
        Object.defineProperty(this, "LoginQuerier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "preLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "postLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ecosystem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.baseUrl = baseUrl;
        this.LoginQuerier = querier;
        this.preLogin = preLogin;
        this.postLogin = postLogin;
        this.client = client;
        this.ecosystem = ecosystem;
    }
    /**
     * @internal
     */
    async sendEmailLoginOtp({ email, }) {
        const result = await this.LoginQuerier.call({
            procedureName: "sendThirdwebEmailLoginOtp",
            params: { email },
        });
        return result;
    }
    /**
     *
     * @internal
     */
    async sendSmsLoginOtp({ phoneNumber, }) {
        const result = await this.LoginQuerier.call({
            procedureName: "sendThirdwebSmsLoginOtp",
            params: { phoneNumber },
        });
        return result;
    }
}
//# sourceMappingURL=abstract-login.js.map